export enum CategoryFilter {
  Video = 'video',
  Files = 'files',
  ELearning = 'eLearning'
}

export enum FilterName {
  Tags = 'tags',
  Status = 'status',
  Attributes = 'attributes',
  Type = 'type'
}
